import { useTheme } from '@mui/material/styles';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './machine-grid.css';

export function useMachineGridTheme() {
  const { palette } = useTheme();
  return 'machine-master-grid ' + (palette.mode === 'dark' ? 'ag-theme-balham-dark' : 'ag-theme-balham');
}
